export default "__VITE_ASSET__tkVjY7fa__"